<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <ModuleViewHeading
              :module-id="access.module_id"
              :profile-id="access.profile_id"
              :reference="access.view_reference"
            />
          </b-col>     
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">        
        <b-row v-if="arr.report">
          <b-col>
            <table class="table table-hover table-sm">
              <tbody>
                <tr v-if="arr.report.id">
                  <td class="reports-visits-detail-title-table-custom align-middle">ID</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <b>{{this.arr.report.id}}</b>
                  </td>
                </tr>            
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Fecha</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    {{moment(this.arr.report.date).format('DD MMMM YYYY')}}
                  </td>
                </tr>

                <tr v-if="arr.report.staff_id">
                  <td class="reports-visits-detail-title-table-custom align-middle">Responsable</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <b-avatar :src="this.arr.report.staff.image"
                              v-if="this.arr.report.staff.image">
                    </b-avatar>
                    <b-avatar v-else                                                                         
                              variant="dark">
                    </b-avatar>                         
                    <b-icon icon="blank"></b-icon>
                    <b :title="'STAFF: ' + this.arr.report.staff.name">
                      {{this.arr.report.staff.name}}
                    </b>   
                  </td>
                </tr>      
                <tr v-else>
                  <td class="reports-visits-detail-title-table-custom align-middle">Responsable</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <b-avatar :src="this.arr.report.seller.staff.image"
                              v-if="this.arr.report.seller.staff.image">
                    </b-avatar>
                    <b-avatar v-else                                                                         
                              variant="dark">
                    </b-avatar>     
                    <b-icon icon="blank"></b-icon>
                    <b :title="'VENDEDOR: ' + this.arr.report.seller.staff.name">
                      {{this.arr.report.seller.staff.name}}
                    </b> 
                  </td>
                </tr>

                <tr v-if="arr.report.customer">
                  <td class="reports-visits-detail-title-table-custom align-middle">Cliente</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">                    
                    <b-avatar :src="this.arr.report.customer.image"
                              v-if="this.arr.report.customer.image">
                    </b-avatar>
                    <b-avatar v-else 
                              icon="building"                                            
                              variant="dark">
                    </b-avatar>     
                    <b-icon icon="blank"></b-icon>
                    <b>{{this.arr.report.customer.name}}</b>  
                    <b-icon icon="circle-fill" v-if="!arr.report.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                                    
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-hover table-sm">
              <tbody>
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Compró</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <b-badge variant="success" v-if="arr.report.buy">SI</b-badge>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                <tr >
                  <td class="reports-visits-detail-title-table-custom align-middle">Supera pedido anterior</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <b-badge variant="success" v-if="arr.report.exceed_previous_order">SI</b-badge>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                <tr v-if="arr.report.reason">                  
                  <td class="reports-visits-detail-title-table-custom align-middle">Motivos</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">                    
                    <div v-if="arr.report.reason.length">
                      <div v-for="(value, index) in arr.report.reason" v-bind:key="index">
                        <b-icon icon="dot"></b-icon> {{value}}
                      </div>
                    </div>
                  </td>                  
                </tr>            
              </tbody>
            </table>
                        
            <table class="table table-hover table-sm">
              <tbody>
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Compró en la competencia</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <b-badge variant="success" v-if="arr.report.buy_competition">SI</b-badge>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                
                <tr v-if="arr.report.name_competition">
                  <td class="reports-visits-detail-title-table-custom align-middle">Nombre de la competencia</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    {{arr.report.name_competition}}
                  </td>
                </tr>
                <tr v-if="arr.report.competition_products">
                  <td class="reports-visits-detail-title-table-custom align-middle">Productos comprado a la competencia</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    {{arr.report.competition_products}}
                  </td>
                </tr>
                
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Por calidad</td>                  
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <b-badge variant="success" v-if="arr.report.quality">SI</b-badge>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Por precio</td>                  
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <b-badge variant="success" v-if="arr.report.price">SI</b-badge>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Por financiación</td>                  
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    <div v-if="arr.report.financing">
                      <b-badge variant="success">SI</b-badge>
                      - {{this.arr.report.financing_detail}}
                    </div>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                <tr>                  
                  <td class="reports-visits-detail-title-table-custom align-middle">Por atención al cliente</td>                  
                  <td class="reports-visits-detail-value-table-custom align-middle">                    
                    <b-badge variant="success" v-if="arr.report.customer_support">SI</b-badge>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Por respuesta ante reclamos</td>                  
                  <td class="reports-visits-detail-value-table-custom align-middle">                    
                    <b-badge variant="success" v-if="arr.report.response_tickets">SI</b-badge>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Por plazo de entregas</td>                  
                  <td class="reports-visits-detail-value-table-custom align-middle"> 
                    <b-badge variant="success" v-if="arr.report.delivery_time">SI</b-badge>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
                <tr>
                  <td class="reports-visits-detail-title-table-custom align-middle">Otros Motivos</td>                  
                  <td class="reports-visits-detail-value-table-custom align-middle"> 
                    <div v-if="arr.report.other_motives">
                      <b-badge variant="success">SI</b-badge>                      
                      - {{this.arr.report.other_motives}}
                    </div>
                    <b-badge variant="danger" v-else>NO</b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <table class="table table-hover table-sm">
              <tbody>
                <tr v-if="arr.report.observations">
                  <td class="reports-visits-detail-title-table-custom align-middle">Observaciones</td>
                  <td class="reports-visits-detail-value-table-custom align-middle">
                    {{this.arr.report.observations}}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>          
        </b-row>
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import moment from 'moment'

  export default {
    data: () => {
      return {      
        access: {
          module_id: Modules.INFORME_VISITAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'detailReport',
          elements: {}
        }, 
        reportID: 0,
        arr: {
          report: null
        }     
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.reportID = this.$route.params.reportID

      this.load()
    },
    methods: {
      validation() {        
        var seller = Helper.getSeller()                        
        if(seller) {          
          if(this.arr.report.sellers_id != seller.id) {
            this.$router.push({ name: 'Error403' })
          }
        }
      },      
      load() {
        var result = serviceAPI.mostrar(this.reportID)

        result.then((response) => {
          var data = response.data
          this.arr.report = data
            
          // VALIDACION DE VISUALIZACION
          this.validation()
          // FIN VALIDACION          
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },    
    }    
  }
</script>
<style>
  .reports-visits-detail-title-table-custom {
    color: #fff;
    background-color: #2f353a;
    border-color: #40484f;
    font-weight: 700;
    padding-right: 10px;
    width: 25%;
    text-align: right
  }
  .reports-visits-detail-value-table-custom {
    padding-left: 5px;
    white-space: pre-line;
  }  
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>